import { getDefaultExportFromCjs } from " commonjsHelpers.js";
import { __require as requireCartDrawer } from "/Users/yvonne/Repositories/2. H1/Shopify-reisartikelen/theme/assets/cart-drawer.js";
var cartDrawerExports = requireCartDrawer();
export { cartDrawerExports as __moduleExports };
export default /*@__PURE__*/getDefaultExportFromCjs(cartDrawerExports);